<script>
export default {
  head: {
    title: 'Outils IA - Assistant Intelligent',
  },
  data: () => ({
    activeVideoUrl: null,
    features: [
      {
        id: 'training_structure',
        icon: 'sitemap',
        title: 'Générer une structure de formation',
        description: 'Votre assistant structure pédagogique crée pour vous le plan complet de votre formation, avec chapitres et leçons adaptés à votre contenu pédagogique.',
        videoUrl: 'https://www.youtube.com/embed/U7AfXCVstpE',
        action: {
          type: 'route',
          label: 'Créer une structure',
          route: { name: 'trainings' },
        },
      },
      {
        id: 'training_content',
        icon: 'file-alt',
        title: 'Générer du contenu de formation',
        description: 'Votre assistant rédaction pédagogique transforme vos notes ou idées en leçons claires, structurées et prêtes à être utilisées, pour vous faire gagner un temps précieux.',
        videoUrl: 'https://www.youtube.com/embed/f30eNQcgXJI',
        action: {
          type: 'route',
          label: 'Générer du contenu',
          route: { name: 'trainings' },
        },
      },
      {
        id: 'title_ideas',
        icon: 'lightbulb',
        title: 'Générer des idées de titres',
        description: 'Votre assistant Copywriter IA vous propose des titres percutants et optimisés pour votre formation afin d’attirer plus d’apprenants.',
        videoUrl: 'https://www.youtube.com/embed/l1Sc5GjVVt0',
        action: {
          type: 'route',
          label: 'Générer des titres',
          route: {
            name: 'ai_assistant_copywriter',
            query: { type: 'title_ideas' },
          },
        },
      },
      {
        id: 'value_proposition',
        icon: 'bullseye',
        title: 'Générer une proposition de valeur',
        description: 'Votre assistant Copywriter IA vous aide à formuler une proposition de valeur claire, différenciante et convaincante, qui met en avant les bénéfices clés de votre offre.',
        videoUrl: 'https://www.youtube.com/embed/WlZNr3CegoI',
        action: {
          type: 'route',
          label: 'Créer ma proposition',
          route: {
            name: 'ai_assistant_copywriter',
            query: { type: 'value_proposition' },
          },
        },
      },
      {
        id: 'outline',
        icon: 'list-ol',
        title: 'Générer un plan de page de vente',
        description: 'Votre assistant Copywriter IA structure pour vous une page complète avec tous les éléments essentiels, pour maximiser vos conversions.',
        videoUrl: 'https://www.youtube.com/embed/p2A-0Xvk1D8',
        action: {
          type: 'route',
          label: 'Créer le plan',
          route: {
            name: 'ai_assistant_copywriter',
            query: { type: 'outline' },
          },
        },
      },
      {
        id: 'sales_page',
        icon: 'file-invoice-dollar',
        title: 'Générer une page de vente complète',
        description: 'Votre assistant Copywriter IA rédige pour vous l’intégralité du texte de votre page de vente, prête à être personnalisée selon votre ton et votre cible.',
        videoUrl: 'https://www.youtube.com/embed/zo2BlQBNhQ0',
        action: {
          type: 'route',
          label: 'Générer la page',
          route: {
            name: 'ai_assistant_copywriter',
            query: { type: 'sales_page' },
          },
        },
      },
    ],
  }),
  methods: {
    openVideoModal(videoUrl) {
      this.activeVideoUrl = videoUrl;
    },
    closeVideoModal() {
      this.activeVideoUrl = null;
    },
    navigateToFeature(action) {
      if (action.type === 'route') {
        this.$router.push(action.route);
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="content mb-5">
      <p class="subtitle is-7">
        Découvrez vos assistants pédagogiques IA, conçus spécialement pour la formation en ligne :
        ils vous accompagnent pour structurer, rédiger et enrichir vos formations en quelques clics !
      </p>
    </div>

    <div class="columns is-multiline">
      <div
        v-for="feature in features"
        :key="feature.id"
        class="column is-6 is-12-mobile"
      >
        <div class="box h-full is-flex is-flex-direction-column">
          <div class="media">
            <div class="media-left p-2 bradius-8 has-background-primary-light">
              <b-icon
                :icon="feature.icon"
                size="is-medium"
                type="is-primary"
              />
            </div>
            <div class="media-content">
              <h2 class="title is-5 mw-260">
                {{ feature.title }}
              </h2>
            </div>
          </div>

          <div class="content mt-5 is-flex-grow-1">
            <p>{{ feature.description }}</p>
          </div>

          <footer class="level">
            <b-button
              type="is-text"
              icon-left="play-circle"
              @click="openVideoModal(feature.videoUrl)"
            >
              Démo
            </b-button>
            <b-button
              type="is-primary"
              class="has-text-black"
              @click="navigateToFeature(feature.action)"
            >
              {{ feature.action.label }}
              <b-icon icon="arrow-right" size="is-small" class="ml-2" />
            </b-button>
          </footer>
        </div>
      </div>
    </div>

    <b-modal
      :active="!!activeVideoUrl"
      :can-cancel="['escape', 'outside']"
      :width="728"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      aria-label="Démonstration vidéo d’un assistant IA Teachizy"
      @close="closeVideoModal"
    >
      <AppCardModal
        style="width: 728px !important; max-width: calc(100vw - 40px);"
        has-close-btn
        @close="closeVideoModal"
      >
        <template #title>
          Démo vidéo
        </template>
        <template #body>
          <figure class="image is-16by9">
            <iframe
              class="pabsolute-0 w-full h-full"
              :src="activeVideoUrl"
              title="Démonstration d’un assistant IA Teachizy"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </figure>
        </template>
        <template #foot>
          <b-button type="is-text" @click="closeVideoModal">
            Fermer
          </b-button>
        </template>
      </AppCardModal>
    </b-modal>
  </div>
</template>
